import { ConstellationData } from './Constellation';

// Define star positions for each constellation (positions match tutorial count from progress service)
export const CONSTELLATION_DATA: ConstellationData[] = [
  {
    name: 'Bear',
    image: 'skybear.png',
    position: { x: 15, y: 12, scale: 1.9, rotation: -15 },
    stars: [
      { x: 9, y: 72 }, { x: 40, y: 74 }, { x: 63, y: 76 }, { x: 85, y: 73 }, { x: 96, y: 37 }
    ]
  },
  {
    name: 'Crane',
    image: 'skycrane.png',
    position: { x: 51, y: 12, scale: 1.8, rotation: 25 },
    railroadZoomFactor: 0.8,
    stars: [
      { x: 40, y: 30 }, { x: 75, y: 40 }, { x: 92, y: 54 }
    ]
  },
  {
    name: 'Frog',
    image: 'skyfrog.png',
    position: { x: 29, y: 52, scale: 2, rotation: -8 },
    stars: [
      { x: 49, y: 23 }, { x: 25, y: 40 }, { x: 70, y: 30 },
      { x: 36, y: 70 }, { x: 72, y: 59 }
    ]
  },
  {
    name: 'Goat',
    image: 'skygoat.png',
    position: { x: 64, y: 32, scale: 1.8, rotation: -12 },
    stars: [
      { x: 24, y: 74 }, { x: 64, y: 74 }, { x: 85, y: 43 },
      { x: 74, y: 20 }
    ]
  },
  {
    name: 'Monkey',
    image: 'skymonkey.png',
    position: { x: 32, y: 24, scale: 1.8, rotation: -20 },
    stars: [
      { x: 37, y: 61 }, { x: 38, y: 39 }, { x: 59, y: 60 },
      { x: 68, y: 58 }, { x: 65, y: 39 }
    ]
  },
  {
    name: 'Mushroom',
    image: 'skymushroom.png',
    position: { x: 56, y: 59, scale: 1.7, rotation: 4 },
    stars: [
      { x: 33, y: 40 }, { x: 66, y: 40 }, { x: 50, y: 35 },
      { x: 49, y: 68 }
    ]
  },
  {
    name: 'Octopus',
    image: 'skyoctopus.png',
    position: { x: 15, y: 76, scale: 1.7, rotation: -12 },
    stars: [
      { x: 50, y: 30 }, { x: 26, y: 26 }, { x: 68, y: 46 },
      { x: 30, y: 65 }, { x: 79, y: 72 }, { x: 46, y: 78 }
    ]
  },
  {
    name: 'Penguin',
    image: 'skypenguin.png',
    position: { x: 80, y: 52, scale: 1.6, rotation: 0 },
    stars: [
      { x: 5, y: 56 }, { x: 45, y: 64 }, { x: 55, y: 50 }, { x: 91, y: 39 }
    ]
  },
  {
    name: 'Rhino',
    image: 'skyrhino.png',
    position: { x: 11, y: 45, scale: 2, rotation: -10 },
    stars: [
      { x: 27, y: 80 }, { x: 45, y: 83 }, { x: 60, y: 84 },
      { x: 85, y: 41 }, { x: 91, y: 37 }
    ]
  },
  {
    name: 'Snake',
    image: 'skysnake.png',
    position: { x: 43, y: 70, scale: 2, rotation: -70 },
    stars: [
      { x: 54, y: 14 }, { x: 63, y: 38 }, { x: 41, y: 50 },
      { x: 64, y: 70 }
    ]
  },
  {
    name: 'Tree',
    image: 'skytree.png',
    position: { x: 45, y: 40, scale: 2, rotation: 0 },
    stars: [
      { x: 51, y: 84 }, { x: 51, y: 65 }, { x: 51, y: 52 }
    ]
  },
  {
    name: 'Virus',
    image: 'skyvirus.png',
    position: { x: 85, y: 78, scale: 1.5, rotation: 5 },
    stars: [
      { x: 49, y: 39 }, { x: 27, y: 76 }, { x: 77, y: 67 }
    ]
  },
  {
    name: 'Wolf',
    image: 'skywolf.png',
    position: { x: 80, y: 10, scale: 1.6, rotation: 5 },
    stars: [
      { x: 31, y: 81 }, { x: 60, y: 80 }, { x: 81, y: 17 }
    ]
  }
];

export const updateConstellationProgress = (
  constellations: ConstellationData[],
  constellationName: string,
  completedChallenges: number
): ConstellationData[] => {
  return constellations.map(constellation => 
    constellation.name === constellationName 
      ? { ...constellation, completedChallenges }
      : constellation
  );
}; 